import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle, faTimes } from "@fortawesome/free-solid-svg-icons";

export interface UnAvailabilityProps {
    message: any;
    handleYes: any;
    handleNo: any;
}

export interface UnAvailabilityState {
    showModal: boolean;
    fileArray?: any[];
    showInvalidFileAlert?: boolean;
    showRemoveModal?: boolean;
}

export class UnAvailability extends React.Component<UnAvailabilityProps, UnAvailabilityState> {
    constructor(props) {
        super(props);
        this.state = { showModal: false };
    }

    render() {
        return (
            <div className="">
                    <div className="containerDialog">
                        <div className="containerDialog-animation">
                            <div className="col-10 col-sm-7 col-xl-4 shadow containerDialoginside">
                                <div className="row blue-accordion">
                                    <div className="col-12  pt-2 pb-2 fontFifteen">
                                        Confirmation
                                        <span className="float-right" onClick={this.props.handleNo}>
                                            <FontAwesomeIcon icon={faTimes} className="mr-1" />
                                            {/* <i className="far fa-arrow-right mr-2 "></i> */}
                                        </span>
                                    </div>
                                </div>
                                <div className="row text-center">
                                    <div className="col-12 text-dark mt-4 pl-2 pr-2">{this.props.message}</div>
                                </div>

                                <div className="row ml-0 mr-0">
                                    <div className="col-12 mt-4 mb-4 text-center font-regular">
                                        <button
                                            type="button"
                                            onClick={this.props.handleNo}
                                            className={"btn button button-close mr-2 shadow mb-2 mb-xl-0"}>
                                            <FontAwesomeIcon icon={faTimesCircle} className="mr-2" />
                                            {"No"}
                                        </button>
                                        <button
                                            type="button"
                                            onClick={this.props.handleYes}
                                            className="btn button button-bg shadow mb-2 mb-xl-0">
                                            <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                                            {"Yes"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}

export default UnAvailability;